module.exports = __webpack_public_path__ + "media/images/project/customization-7cdb0554fae708e74ec77437ac2fa5b8.svg";